/** OutlierOS "Account suspended" screen. */
import { LogOut, ShieldAlert } from 'lucide-react';
import { BRAND } from '@vw/core/src/brand';
import { Button } from '@vw/ui';
import { api } from '../api';
import { navigate } from '../router';

export function Suspended() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md space-y-4 rounded-2xl border border-border bg-card p-8 text-center shadow-2xl">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-rose-500/10 text-rose-500"><ShieldAlert className="h-7 w-7" /></span>
        <h1 className="text-xl font-extrabold">Account suspended</h1>
        <p className="text-sm text-muted-foreground">Your {BRAND.name} account has been suspended, so the dashboard, the extension and transcription are unavailable. If you think this is a mistake, contact support.</p>
        <a className="block text-sm font-semibold text-primary" href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</a>
        <Button variant="secondary" onClick={async () => { await api('/api/auth/logout', { method: 'POST' }).catch(() => undefined); navigate('/signin'); }}><LogOut className="h-3.5 w-3.5" />Sign out</Button>
      </div>
    </div>
  );
}
